import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import { MAT_DIALOG_DATA, MatDialogRef,MatDialog } from "@angular/material";
import { DeleteSpendBudgetFeebackLeaddeliveryComponent } from '../delete-spend-budget-feeback-leaddelivery/delete-spend-budget-feeback-leaddelivery.component';

@Component({
  selector: 'app-lead-delivery-list',
  templateUrl: './lead-delivery-list.component.html',
  styleUrls: ['./lead-delivery-list.component.scss']
})
export class LeadDeliveryListComponent implements OnInit {

  authToken = localStorage.getItem("token")
  // public authInfo = JSON.parse(localStorage.getItem("authInfo"));
  userInfo: any = JSON.parse(localStorage.getItem("userInfo"));

  leadDeliveryList: any;
  showComponentLoader: boolean = true;

  campaignRowData:any;
  deleteSpendBudgetFeebackLeaddeliveryComponent:MatDialogRef<DeleteSpendBudgetFeebackLeaddeliveryComponent>;

  headerStats:any;
  otherPlatformStats:any;

  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<LeadDeliveryListComponent>,
    private datePipe: DatePipe,
    private dialog:MatDialog,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    //console.log(data)
    this.campaignRowData = data;
  }

  ngOnInit() {
    this.getLeadDeliveryList()
    this.getSpentBudgetDeliveryStats()
  }
  getNum(spent:any,lead:any):any{
    let s = this.removeCommas(spent)
    let d = this.removeCommas(lead)
    return (Number(s)/Number(d)).toFixed(2)
  }
  removeCommas(value: any): string {
    if (!value) return "0";
    return typeof value === "string"
      ? value.replace(/,/g, "")
      : value.toString();
  }

  getSpentBudgetDeliveryStats() {

    this.showComponentLoader = true;

    let url = "campaign_module/campaign/spent_budget_delivery_stats/"+this.data.id;

    this.serverService.getSpentBudgetDeliveryStats(url, this.authToken).subscribe(data => {
      //console.log(data)
      this.headerStats = data.stats[data.stats.length-1];
      this.otherPlatformStats = data.stats;
      //console.log(this.headerStats)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  getLeadDeliveryList() {

    this.showComponentLoader = true

    let url = "/campaign_module/campaign/campaign_lead_deliveries?campaign_id="+this.campaignRowData.id;
    
    this.serverService.getDeliveryLeadList(url, this.authToken).subscribe(data => {
        this.leadDeliveryList = data.campaign_lead_deliveries
        //console.log(this.leadDeliveryList)
        this.showComponentLoader = false
    }, err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
    })

}

  close() {
    this.dialogRef.close();
}
deleteSpend(item:any,type:any){
  item['type'] = type;
  this.deleteSpendBudgetFeebackLeaddeliveryComponent = this.dialog.open(DeleteSpendBudgetFeebackLeaddeliveryComponent, {
    hasBackdrop: true,
    disableClose: false,
    autoFocus: true,
    width: '520px',
    panelClass: 'blue-snackbar',
    data: item
  });
  this.deleteSpendBudgetFeebackLeaddeliveryComponent.afterClosed().subscribe(result => {
    // console.log(result)
    if(result != undefined){
      this.leadDeliveryList = this.leadDeliveryList.filter((item)=>item.id != result.id)
    //  console.log(this.brochures)
    this.getSpentBudgetDeliveryStats()
      }
      
  });
  
}
}